import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { getStringDate } from 'src/app/common/util';
import { PaginationComponent } from 'src/app/components/elements/pagination/pagination.component';
import { CatalogConfigResponse, RecurrenceResponse } from 'src/app/models/recurrence.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { PriceClientResponse, SaleResponse } from 'src/app/models/sale.model';
import { CotService } from 'src/app/services/cot.service';
import { RecurrenceService } from 'src/app/services/recurrence.service';
import { Modal } from 'bootstrap';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { CashierService } from 'src/app/services/cashier.service';

@Component({
  selector: 'app-history-recurrence',
  templateUrl: './history-recurrence.component.html',
  styleUrls: ['./history-recurrence.component.scss','../historical/historical.component.scss']
})
export class HistoryRecurrenceComponent {
  waitingFor = null;
  deleting: { [key: string]: boolean } = {};
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  recurrenceObject: RecurrenceResponse = null;
  recurrenceObject1: CatalogConfigResponse[] = null;
  search = "";
  gettingRecurrence = false;
  @ViewChild(PaginationComponent) paginationComponent: PaginationComponent;
  recurrenceDetail: any = null;

  constructor(
    private toastService: ToastrService,
    private recurrence: RecurrenceService,
    private authService: AuthenticationService,
    private cashierService: CashierService,
  ) {
    const today = new Date();
  }


  convertToString(date: number) {
    if (!date) {
      return '';
    }
    var tempDate = new Date(date);
    return getStringDate(tempDate);
  }


  ngOnInit(): void {
    this.loadConfigurations();
  }

  getBegin() {
    this.recurrence.getBegin().subscribe(
      {
        next: (response: ResponseObject) => {
          this.recurrenceObject = response.data;
          console.log(this.recurrenceObject);
          this.pagination.total = this.recurrenceObject.catalogConfig;
          this.paginationComponent.reset();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      }
    );

  }

  loadConfigurations() {    
    this.recurrence.getAllRecurrenceConfigurations(
      this.authService.getCurrentCompanyId(),
      this.search, // warehouse
      this.search  // name
    ).subscribe({
      next: (response: ResponseObject) => {
        this.recurrenceObject1 = response.data;
        this.pagination.total = this.recurrenceObject1;
        this.paginationComponent.reset();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  resetDeletingDiv() {
    this.waitingFor = null;
  }


  
  showRecurrenceDetail(factId: number) {
    this.gettingRecurrence = true;
  
    this.recurrence.getRecurrenceByFactId(factId).subscribe({
      next: (response: ResponseObject) => {
        this.recurrenceDetail = response.data;
        this.gettingRecurrence = false;
        this.generateSummaries();
  
        if (this.recurrenceDetail.cashierId) {
          this.getCashier(this.recurrenceDetail.cashierId);
        } else {
          this.cashierName = '';
        }
      },
      error: () => {
        this.toastService.error('No se pudo obtener el detalle.');
        this.gettingRecurrence = false;
      }
    });
  }

  deleteRecurrence(x: any) {
    this.waitingFor = x;
  }

  confirmDelete(recurrence: any) {
    if (this.deleting[recurrence.id]) {
      return;
    }
    this.deleting[recurrence.id] = true;
    this.waitingFor = null;
    this.recurrence.deleteRecurrence(recurrence.factId).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Se ha eliminado la configuración correctamente!");
        this.getBegin();
        delete this.deleting[recurrence.id];
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al eliminar");
        delete this.deleting[recurrence.id];
      }
    });
  }

  resetPagination() {
    this.paginationComponent.reset();
  }

  cashierName = '';

  getCashier(cashierId: number) {
    this.cashierService.getCashsById(cashierId).subscribe({
      next: (response: ResponseObject) => {
        this.cashierName = response.data.name || '';
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
        this.cashierName = 'Error al obtener';
      }
    });
  }

  searching() {
    this.pagination.total = this.recurrenceObject1.filter((sale) => {
      return sale.id + '' == this.search || sale.name.toLowerCase().includes(this.search.toLowerCase())
      || sale.recurrence.toLowerCase().includes(this.search.toLowerCase())
    });
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  msToTime(ms: number): string {
    // Asegurarnos de que esté dentro de un día de 24h
    const msInDay = 24 * 60 * 60 * 1000;
    ms = ms % msInDay;
  
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
  
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  productSummary: { name: string; totalQuantity: number; totalPrice: number }[] = [];
  clientSummary: { name: string; count: number }[] = [];

  generateSummaries() {
    if (!this.recurrenceDetail) return;

    const productMap = new Map<number, { name: string; totalQuantity: number; totalPrice: number; limitProduct: number }>();
    const clientMap = new Map<string, number>();

    // Agrupar productos por ID
    this.recurrenceDetail.products?.forEach((p: any) => {
      const id = p.id;
      if (!productMap.has(id)) {
        productMap.set(id, { name: p.name, totalQuantity: 0, totalPrice: 0, limitProduct: 0 });
      }
      const entry = productMap.get(id)!;
      entry.totalQuantity += p.quantity;
      entry.totalPrice += p.quantity * p.price;
      entry.limitProduct = p.limitProduct;
    });

    // Agrupar clientes por nombre
    this.recurrenceDetail.clients?.forEach((c: any) => {
      const key = c.name || 'Desconocido';
      clientMap.set(key, (clientMap.get(key) || 0) + 1);
    });

    this.productSummary = Array.from(productMap.values());
    this.clientSummary = Array.from(clientMap.entries()).map(([name, count]) => ({
      name,
      count,
    }));
  }

  
}
